import { render } from "./RegistrationFishingData.vue?vue&type=template&id=6437b20a&scoped=true&ts=true"
import script from "./RegistrationFishingData.vue?vue&type=script&lang=ts"
export * from "./RegistrationFishingData.vue?vue&type=script&lang=ts"

import "./RegistrationFishingData.vue?vue&type=style&index=0&id=6437b20a&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6437b20a"]])

export default __exports__